"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
require("react-datepicker/dist/react-datepicker.css");
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../..");
var StyledDatePicker = (0, styled_components_1.default)(react_datepicker_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & > .date-selector {\n    font-family: ", ";\n    border-radius: 4px;\n  }\n\n  & > .react-datepicker__input-container {\n    border: ", " !important;\n  }\n\n  & > .react-datepicker__day--selected {\n    border-color: ", ";\n  }\n"], ["\n  & > .date-selector {\n    font-family: ", ";\n    border-radius: 4px;\n  }\n\n  & > .react-datepicker__input-container {\n    border: ", " !important;\n  }\n\n  & > .react-datepicker__day--selected {\n    border-color: ", ";\n  }\n"])), function (props) { return props.theme.font; }, function (props) { return props.theme.colors[0]; }, function (props) { return props.theme.colors[0]; });
var DateSelector = function (_a) {
    var state = _a.state, setState = _a.setState;
    var handleDateChange = function (date) {
        setState(date);
    };
    var theme = (0, __1.useEloise)().theme;
    return (react_1.default.createElement("div", { className: "date-selector" },
        react_1.default.createElement(StyledDatePicker, { theme: theme, selected: state, onChange: handleDateChange, dateFormat: "yyyy-MM-dd", isClearable: true, showPopperArrow: false, placeholderText: "Select or type a date" })));
};
exports.default = DateSelector;
var templateObject_1;
